import styled from "styled-components";

export const Main = styled.div`
  width: 100%;
  height: 100vh;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  margin: 0 auto;

  background-color: #e7e7e7;
  background: url("img/bgmain.jpg");

  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  @media screen and (max-width: 500px) {
    width: 100%;
    /* background: no-repeat center/100% url("img/loginback04.png"); */
  }
`;

export const LoginWrap = styled.div`
  width: 500px;
  flex-direction: column; /* 세로 방향으로 요소 정렬 */
  align-items: center; /* 수평 방향 중앙 정렬 */
  margin: 0 auto; /* 수평 중앙 정렬 */

  @media screen and (max-width: 500px) {
    width: 100%;
    /* background: no-repeat center/100% url("img/loginback04.png"); */
  }
`;

/************************************************** */
export const TitleWrap = styled.div`
  margin-top: 87px;
  text-align: center;
  font-size: 28px;
  font-weight: 900;
  color: #658a47;
  padding: 0 20px;
`;

export const ContentWrap = styled.div`
  margin-top: 26px;
  flex: 1 0 1;
  padding: 0 20px;
`;

export const InputTitle = styled.div`
  font-size: 12px;
  font-weight: 400;
  color: #262626;
`;

export const InputWrap = styled.div`
  display: flex;
  border-radius: 8px;
  padding: 16px;
  margin-top: 8px;
  background-color: white;
  border: 1px solid #e2e0e0;
`;

export const Input = styled.div`
  width: 100%;
  outline: none;
  border: none;
  height: 17px;
  font-size: 14px;
  font-weight: 400;
`;

export const ErrorMessageWrap = styled.div`
  margin-top: 8px;
  color: #ef0000;
  font-size: 12px;
`;

export const ButtonWrap = styled.div`
  flex: 1 0 1;
  margin-top: 20px;
  padding: 0 20px;
`;

export const BottomButton = styled.div`
  background-color: #735c3a;
  width: 100%;
  height: 48px;
  border: none;
  font-weight: 700;
  border-radius: 64px;
  color: white;
  cursor: pointer;
`;

export const Hr = styled.hr`
  background-color: #dadada;
  margin-top: 16px;
  border: none;
  height: 0.3px;
  width: 90%;
`;

export const RegisterWrap = styled.div`
  flex: 1 0 1;
  margin-top: 5px;
`;

export const RegisterTitle = styled.div`
  font-size: 12px;
  font-weight: 400;
  color: #919191;
  text-align: center;
`;

export const A = styled.a`
  text-decoration: none;
  font-weight: 800 !important;
  color: #735c3a !important;
  cursor: pointer;
`;

/*
.bottomButton:disabled {
  background-color: #dadada;
  color: white;
}
*/
